<div class="toolbar-title" [ngClass]="'toolbar-title-' + _mode"><ng-content></ng-content></div>